import { getTripsPerMonth } from "@/api/group";
import GroupDashboardImg1 from "@/assets/image/group_report_1.png";
import GroupDashboardImg2 from "@/assets/image/group_report_2.png";
import GroupDashboardImg3 from "@/assets/image/group_report_3.png";
import { Loader, Modal } from "@/components";
import CustomizedHook from "@/components/project/autocomplatePro";
import Card from "@/pages/admin/dashboard/components/Card";
import { Grid, useMediaQuery } from "@mui/material";
import { BarChart } from "@mui/x-charts";
import { useCallback, useEffect, useMemo, useState } from "react";
import AllTripsInfoCard from "./AllTripInfoCard";
import IranMap from "./IranMapCanvas";

const monthLabels = [
  "فروردین",
  "اردیبهشت",
  "خرداد",
  "تیر",
  "مرداد",
  "شهریور",
  "مهر",
  "آبان",
  "آذر",
  "دی",
  "بهمن",
  "اسفند",
];

function AllTripsInfo({ allTripsInfo }) {
  const [fetchingPerMonth, setFetchingPerMonth] = useState(false);
  const [year, setYear] = useState("1405");
  const md = useMediaQuery("(max-width:450px)");
  const [perMonthData, setPerMonthData] = useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [barColors, setBarColors] = useState();
  useEffect(() => {
    if (!perMonthData) return;
    setBarColors(
      perMonthData.map((val) => {
        if (val > 4) return "#4caf50";
        if (val < 3) return "#f44336";
        return "#ff9800";
      }),
    );
  }, [perMonthData]);

  const yearOptions = useMemo(() => {
    return [
      {
        value: "1402",
        name: "1402",
      },
      {
        value: "1403",
        name: "1403",
      },
      {
        value: "1404",
        name: "1404",
      },
      {
        value: "1405",
        name: "1405",
      },
      {
        value: "1406",
        name: "1406",
      },
    ];
  }, []);

  const fetchTripsPerMonth = useCallback(() => {
    if (!year) return;
    setFetchingPerMonth(true);
    getTripsPerMonth(year)
      .then((res) => {
        setPerMonthData(res.map((e) => e.count));
      })
      .catch(() => {})
      .finally(() => setFetchingPerMonth(false));
  }, [year]);

  useEffect(() => {
    fetchTripsPerMonth();
  }, [year]);

  return (
    <>
      <Grid
        display={"flex"}
        flexDirection={"row"}
        gap={"20px"}
        flexWrap={'nowrap'}
        sx={md ? { maxWidth: "100%", overflowX: "auto", minHeight: '370px' } : {}}
      >
        <AllTripsInfoCard
          img={GroupDashboardImg1}
          title={"سوابق اردوها"}
          desc={"شما میتوانید اردوهای برگزار شده خود را مشاهده کنید."}
        />
        <AllTripsInfoCard
          img={GroupDashboardImg2}
          title={"ایجاد اردو"}
          desc={"شما میتوانید پروژه‌های خود را ببینید و اردو را ایجاد کنید."}
        />
        <AllTripsInfoCard
          img={GroupDashboardImg3}
          title={"اردوهای در حال برگزاری"}
          desc={"شما میتوانید اردوهای جاری را مشاهده و مدیریت کنید."}
        />
      </Grid>
      <Grid display={"flex"} flexDirection={md ? "column" : "row"} gap={"30px"}>
        <Grid
          display={"flex"}
          flexDirection={"column"}
          gap={"10px"}
          width={md ? "100%" : "480px"}
        >
          <Grid
            display={"flex"}
            flexDirection={"row"}
            gap={"10px"}
            justifyContent={"space-between"}
            flexWrap={"wrap"}
          >
            <Card
              title={"تعداد اردو"}
              counter={allTripsInfo.tripCount}
              unit={"اردو"}
              width="230px"
            />
            <Card
              title={"تعداد مناطق"}
              counter={allTripsInfo.areaCount}
              unit={"منطقه"}
              width="230px"
            />
            <Card
              title={"تعداد استان‌ها"}
              counter={allTripsInfo.stateCount}
              unit={"استان"}
              width="230px"
            />
            <Card
              title={"تعداد شهرها"}
              counter={allTripsInfo.cityCount}
              unit={"شهر"}
              width="230px"
            />
          </Grid>

          <Modal
            title={"برگزاری اردو بر اساس ماه"}
            width={"100%"}
            actionButton={
              <CustomizedHook
                width={md ? "80px" : "100px"}
                parentWidth={md ? "80px" : "100px"}
                maxWidth={md ? "80px" : "100px"}
                placeholder="انتخاب کنید."
                options={yearOptions}
                onChange={(_, newValue) => setYear(newValue.value)}
                value={yearOptions.find((e) => e.value === year)}
              />
            }
          >
            <Grid
              display={"flex"}
              flexDirection={"row"}
              gap={"10px"}
              alignItems={"center"}
            >
              {fetchingPerMonth && <Loader />}
              {!fetchingPerMonth && perMonthData && barColors && (
                <BarChart
                  leftAxis={null}
                  height={200}
                  margin={{ top: 5, bottom: 60, left: 5, right: 5 }}
                  series={[
                    {
                      data: perMonthData,
                      type: "bar",
                    },
                  ]}
                  xAxis={[
                    {
                      scaleType: "band",
                      data: monthLabels,
                      tickLabelStyle: {
                        angle: -90,
                        textAnchor: "center",
                        fontSize: 12,
                      },
                      colorMap: {
                        type: "ordinal",
                        values: monthLabels,
                        colors: barColors,
                      },
                    },
                  ]}
                />
              )}
            </Grid>
          </Modal>
        </Grid>
        <IranMap />
      </Grid>
    </>
  );
}

export default AllTripsInfo;
